import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export function useLoginMutation() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (variables: Parameters<typeof SSF.api.authLoginCreate>[0]) => SSF.api.authLoginCreate(variables),
    onSuccess: () => client.resetQueries(),
  });
}
